<div class="network-panel" [style.background]="networkStateColor()">
  {{ networkStateText() | translate }}
</div>
